export default "__VITE_ASSET__90986125__"